import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const LatestStories = () => {
  const [latestNews, setLatestNews] = useState([]);

  useEffect(() => {
    const fetchLatestNews = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}product`
        );

        // newest first, only 4
        setLatestNews(res.data.slice(0, 4));
      } catch (err) {
        console.error("Failed to fetch latest stories", err);
      }
    };

    fetchLatestNews();
  }, []);

  return (
    <div className="bg-white rounded-lg border shadow-sm ">
      {/* HEADER */}
      <div className="px-4 py-3 border-b">
        <h3 className="font-bold text-red-600 text-[18px] uppercase tracking-wide">
          Latest Stories
        </h3>
      </div>

      {/* STORIES */}
      <div>
        {latestNews.map((item) => (
        <Link
            key={item.id}
            to={`/news/${item.id}`}
            className="flex gap-3 p-2 hover:bg-gray-50 transition group"
          >
            <img
              src={`${process.env.REACT_APP_BACKEND_URL.replace(
                "/api/v1/",
                ""
              )}/uploads/news/${item.thumbnail}`}
              alt={item.news_title}
              className="w-20 h-14 object-cover rounded"
            />

            <p className="text-sm text-gray-800 font-medium leading-snug line-clamp-2 group-hover:text-red-600">
              {item.news_title}
            </p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default LatestStories;
